export default function getStyles() {
  return {
    '@global': {

    },
    marginContainer: {
      marginLeft: 32,
      marginTop: 32,
      paddingRight: 30,
      display: 'flex',
      overflow: 'auto',
      flex: '1 0 1px',
      flexDirection: 'column',
    },
  };
}
